import { c as _c } from "react/compiler-runtime";
import { HotelCard, HotelInfo } from "@website/accommodation-ui/hotel-card-new";
import { HotelCardPricing } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-pricing";
import { HotelCardReservationInfo } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-reservation-info";
import ErrorArt from "@website/accommodation-ui/hotel-cities-main-content/assets/error-art.png";
import NotFoundArt from "@website/accommodation-ui/hotel-cities-main-content/assets/not-found-art.png";
import { useHotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content/hotel-cities-main-content.hook";
import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content/hotel-cities-main-content.types";
import { HotelSuggestionCarousel } from "@website/accommodation-ui/hotel-cities-main-content/hotel-suggestion-carousel";
import { HotelLastSecondCityPage } from "@website/accommodation-ui/hotel-last-second";
import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header";
import { HotelCardSkeleton } from "@website/accommodation-ui/hotel-pagination/hotel-card-skeleton";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { USER_TRACKING_EVENTS, WEBENGAGE_EVENTS } from "@website/tracking/tracking.types";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import { ApplicationNameType, addEventToTracking, mapProductForUserTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { Switch } from "@website/ui/switch";
import { isChannel } from "@website/utils/channel/helpers";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { redirectToHome } from "@website/utils/redirect-to-home";
import { AccommodationBanner } from "@website/widget/accommodation-banner";
import { BannerSlide } from "@website/widget/banner-slide";
import { ReserveCommentPropertiesType } from "@website/widget/reserve-comment";
import { ReserveCommentPopupScroll } from "@website/widget/reserve-comment-popup-scroll";
import { useReserveGalleryDetailContainer } from "@website/widget/reserve-gallery";
import { ReserveGalleryDetail, ReserveGallerySingle } from "@website/widget/reserve-gallery-detail";
import { ReserveMap } from "@website/widget/reserve-map";
import last from "lodash-es/last";
import map from "lodash-es/map";
import omit from "lodash-es/omit";
import orderBy from "lodash-es/orderBy";
import range from "lodash-es/range";
import toNumber from "lodash-es/toNumber";
import uniq from "lodash-es/uniq";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { FC, Fragment, useEffect, useState } from "react";
import { hotelCardOnClick } from "../hotel-card-new/hotel-card-link";
const appName = process.env.NEXT_PUBLIC_APP_NAME as ApplicationNameType;
const PageMessage = dynamic(() => import("./hotel-page-message").then(({
  PageMessage
}) => PageMessage), {
  ssr: false
});
const PageNotFound = t0 => {
  const $ = _c(15);
  const {
    cityTitle,
    hasFilters,
    hideDefaultNoResult,
    noResultContent,
    onActionClick
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== cityTitle || $[1] !== hasFilters || $[2] !== router.pathname || $[3] !== router.query.locationType) {
    t1 = router.query.locationType === "category" && !hasFilters ? <>متاسفانه در حال حاضر اقامتگاهی متناسب با دسته‌بندی انتخابی شما یافت نشد.</> : hasFilters ? <>متاسفانه در حال حاضر هتل و اقامتگاهی متناسب با فیلتر های انتخابی شما وجود ندارد .</> : router?.pathname?.includes("map") ? <span>متاسفانه هتل و اقامتگاه فعالی در این محدوده یافت نشد. لطفا شهرهای دیگر را جستجو کنید.</span> : <>متاسفانه هتل و اقامتگاه فعالی در شهر{" "}<span className="text-on-surface-high-emphasis font-medium">"{cityTitle}"</span>{" "}یافت نشد. لطفا شهرهای دیگر را جستجو کنید.</>;
    $[0] = cityTitle;
    $[1] = hasFilters;
    $[2] = router.pathname;
    $[3] = router.query.locationType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const defaultCaption = t1;
  if (hideDefaultNoResult && !noResultContent) {
    return null;
  }
  let t2;
  if ($[5] !== hasFilters || $[6] !== noResultContent) {
    t2 = noResultContent ? noResultContent.actionIcon ?? null : hasFilters ? <MaterialIcon name="delete_outline" /> : null;
    $[5] = hasFilters;
    $[6] = noResultContent;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = noResultContent?.actionTitle ?? (hasFilters ? "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627" : "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0642\u0635\u062F");
  const t4 = noResultContent?.caption ?? defaultCaption;
  const t5 = noResultContent?.message ?? "\u0646\u062A\u06CC\u062C\u0647\u200C\u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.";
  const t6 = noResultContent?.messageClassName;
  const t7 = noResultContent?.onActionClick ?? onActionClick;
  let t8;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <PageMessage actionIcon={t2} actionTitle={t3} artSrc={NotFoundArt.src} caption={t4} message={t5} messageClassName={t6} onActionClick={t7} />;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
const PageError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PageMessage actionIcon={<MaterialIcon name="arrow_forward" />} actionTitle={"\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0627\u0635\u0644\u06CC"} artSrc={ErrorArt.src} caption={"\u0645\u062A\u0627\u0633\u0641\u0627\u0646\u0647 \u0627\u0637\u0644\u0627\u0639\u0627\u062A\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F."} message={"\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F\u0647 \u0627\u0633\u062A!"} onActionClick={redirectToHome} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const HotelCitiesMainContent: FC<HotelCitiesMainContentPropertiesType> = properties => {
  const $ = _c(19);
  const {
    size,
    cityTitle,
    hotelsSuggested,
    snappPayData,
    bannerSlideList,
    inlineBannerList,
    isBannersLoading,
    hasLoadMoreButton: t0,
    lastSecondHotelsList,
    lastSecondHotelsLoading,
    accommodationData,
    className,
    hideDefaultNoResult,
    targetLink,
    onMouseEnter,
    onMouseLeave,
    selectedHotelId,
    totalItem,
    reviewData,
    hasCityNearby,
    hideMobileCityTitle,
    noResultContent,
    noFollow
  } = properties;
  const hasLoadMoreButton = t0 === undefined ? false : t0;
  const {
    hotelList,
    loading,
    hasNoResults,
    hasError,
    hasSort,
    hasFilters,
    hasHotelSuggestion,
    suggestionOrder,
    onLoadMore,
    remainHotels,
    handleNotFoundAction
  } = useHotelCitiesMainContent(properties);
  const router = useRouter();
  const {
    isMobile,
    isTablet
  } = useViewPort();
  const [clickLoading, setClickLoading] = useState(0);
  let t1;
  if ($[0] !== hotelList) {
    t1 = hotelList.filter(_temp);
    $[0] = hotelList;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const availableHotels = t1;
  let t2;
  if ($[2] !== hotelList || $[3] !== hotelsSuggested?.length || $[4] !== lastSecondHotelsList?.length || $[5] !== loading || $[6] !== router.query) {
    t2 = () => {
      const [hotelInfo] = hotelList;
      if (!hotelInfo?.hotelDetail.cityId || loading) {
        return;
      }
      const availableHotels_0 = hotelList.filter(_temp2);
      addEventToWebengage(appName === "hotel-international" ? WEBENGAGE_EVENTS.IH_cityVisit : WEBENGAGE_EVENTS.CITY_VISIT, {
        "page title": document.title,
        "city name": hotelInfo?.hotelDetail.cityTitle,
        "check in date": router.query.date_from || "",
        "check out date": router.query.date_to || "",
        "page url": window.location.href
      });
      if (["villa", "hotel-domestic", "hotel-international"].includes(appName)) {
        addEventToTracking(USER_TRACKING_EVENTS.PAGE_VISIT_CITY, {
          city: hotelInfo?.hotelDetail.cityTitle,
          city_id: hotelInfo?.hotelDetail.cityId,
          date_from: new Date(router.query.date_from as string),
          date_to: new Date(router.query.date_to as string),
          available_hotels_id: availableHotels_0.map(_temp3),
          page: last(orderBy(uniq(map(availableHotels_0, "page")))),
          product: mapProductForUserTracking(appName),
          last_minute_loaded: lastSecondHotelsList?.length ? 1 : 0,
          count_of_last_minute_cards: lastSecondHotelsList?.length,
          blue_box_loaded: hotelsSuggested?.length ? 1 : 0,
          count_of_blue_box_cards: hotelsSuggested?.length
        });
      }
    };
    $[2] = hotelList;
    $[3] = hotelsSuggested?.length;
    $[4] = lastSecondHotelsList?.length;
    $[5] = loading;
    $[6] = router.query;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = hotelsSuggested?.length;
  const t4 = lastSecondHotelsList?.length;
  let t5;
  if ($[8] !== hotelList || $[9] !== loading || $[10] !== router || $[11] !== t3 || $[12] !== t4) {
    t5 = [hotelList, t3, t4, loading, appName, router];
    $[8] = hotelList;
    $[9] = loading;
    $[10] = router;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t2, t5);
  let t6;
  if ($[14] !== router) {
    t6 = () => router.replace({
      pathname: router?.pathname,
      query: omit(router?.query, ["modal", "selectedHotelId"])
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[14] = router;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onClose = t6;
  let t7;
  if ($[16] !== router.query?.modal || $[17] !== selectedHotelId) {
    t7 = hotel_2 => ["villa"].includes(appName) && router?.query?.modal === "review" ? hotel_2.hotelDetail?.propertyId === Number(selectedHotelId) : hotel_2.id === Number(selectedHotelId);
    $[16] = router.query?.modal;
    $[17] = selectedHotelId;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const selectedHotel = hotelList.find(t7) as HotelInfo;
  const {
    containerProps
  } = useReserveGalleryDetailContainer({
    templateNumber: 4,
    galleryLength: selectedHotel?.gallery?.length ?? 0
  });
  return hasError ? <PageError /> : hasNoResults ? <div className="flex w-full flex-col items-center justify-center">{accommodationData?.cityTitle && isChannel(["website", "jek"]) && <AccommodationBanner cityTitle={accommodationData?.cityTitle} onclick={accommodationData?.onClick} />}<PageNotFound cityTitle={cityTitle} hasFilters={hasFilters} hideDefaultNoResult={hideDefaultNoResult} noResultContent={noResultContent} onActionClick={handleNotFoundAction} /></div> : <><HotelLastSecondCityPage cityTitle={cityTitle} lastSecondHotels={lastSecondHotelsList} loading={lastSecondHotelsLoading} /><section className={`${className || (size === "small" ? "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" : "flex w-full flex-col items-center gap-4 lg:gap-6")}`}>{hasHotelSuggestion && !hasFilters && !hasSort && hotelList?.length > 0 && <section className={`col-span-full w-full ${suggestionOrder === 1 ? "order-1" : suggestionOrder === 2 ? "order-2" : suggestionOrder === 3 ? "order-3" : ""} ${size === "small" ? "sm:order-2 lg:order-3" : ""}`}><HotelSuggestionCarousel hotelsSuggested={hotelsSuggested} noFollow={noFollow} /></section>}{!hideMobileCityTitle && <div className="col-span-1 -mt-5 block self-start sm:col-span-2 lg:col-span-3 lg:mt-0 lg:hidden"><div className="flex w-full flex-row items-center justify-between gap-4"><HotelCityTitle city={cityTitle} hasCityPrefix={router.query.locationType !== "category"} loading={loading} totalItem={totalItem} />{hasCityNearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" && <Switch name="nearby" key={`nearby=${router.query?.nearby}`} label={"\u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"} checked={Boolean(router.query?.nearby)} onChange={() => router.replace({
            query: deepOmit({
              ...omit(router.query, ["geo_property_summary"]),
              nearby: !router.query?.nearby || undefined
            }, isFilled)
          }, undefined, {
            shallow: true,
            scroll: false
          })} color="secondary" className="!text-body-2 flex flex-row-reverse !items-center !justify-end !whitespace-nowrap !pb-0 !pt-[20px] lg:!hidden" />}</div></div>}{hotelList?.map((hotelInfo_0, index) => <Fragment key={hotelInfo_0?.id}>{(bannerSlideList?.length ?? 0) > 0 && index === 1 && <div className={appName === "villa" ? "-order-1 col-span-1 gap-4 sm:col-span-2 lg:col-span-3" : "w-full"}><BannerSlide className="w-full !p-0" height={isMobile ? 87 : isTablet ? 175 : 70} isLoading={isBannersLoading} list={bannerSlideList ?? []} noFollow={noFollow} width={isMobile ? 378 : isTablet ? 760 : 812} shouldRedirectUsingJs={true} /></div>}{accommodationData?.cityTitle && index === (availableHotels.length > 0 ? availableHotels?.length - 1 : 0) && isChannel(["website", "jek"]) && <div className="w-full" style={{
          order: availableHotels.length > 0 ? availableHotels?.length : 0
        }}><AccommodationBanner cityTitle={accommodationData?.cityTitle} onclick={accommodationData?.onClick} /></div>}{(inlineBannerList?.length ?? 0) > 0 && index === 3 && <div className="order-4 w-full"><BannerSlide className="w-full !p-0" height={72} isLoading={isBannersLoading} list={inlineBannerList ?? []} noFollow={noFollow} shouldRedirectUsingJs={true} /></div>}<article className="w-full" style={{
          order: index
        }}><HotelCard hotelInfo={hotelInfo_0} index={index + 1} isPriorityImage={index === 0} key={hotelInfo_0?.hotelDetail?.hotelTitle} loading={loading} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onLinkClick={hotelInfo_0.onLinkClick} showMap={Boolean(hotelInfo_0?.location?.lat) && Boolean(hotelInfo_0?.location?.lng)} noFollow={Boolean(noFollow || hotelInfo_0?.noFollow)} size={size} snappPayData={snappPayData} targetLink={targetLink} actionButtonText={hotelInfo_0.transportation?.text} /></article></Fragment>)}<Modal className="!h-[90vh] overflow-y-scroll rounded-xl md:!h-full md:rounded-none md:[clip-path:inset(0_round_1rem)] lg:!h-[640px] lg:!w-[720px]" headerStyle="!h-16 pb-2" onClose={onClose} open={selectedHotel && router?.query?.modal === "review" && (reviewData?.comments?.length ?? 0) > 0} showCloseButton={true} title={numberConvert(selectedHotel?.hotelDetail?.hotelTitle, {
        locale: router.locale || "fa"
      })} titleClassName="line-clamp-2" usePortal={true}><ReserveCommentPopupScroll comments={reviewData?.comments as Array<ReserveCommentPropertiesType>} onClick={hotelCardOnClick({
          hotelInfo: selectedHotel,
          index: hotelList?.findIndex(hotel_3 => hotel_3.id === selectedHotel?.id),
          router,
          setClickLoading,
          hash: "#hotel_comments"
        })} rate={reviewData?.rate} size="small" /><div className="sticky bottom-0 -mx-4 -mb-4 mt-auto"><div className="-mb-6 flex w-full flex-row bg-white p-4 md:justify-end"><Button className="!hidden md:!block" color="neutral" onClick={onClose} text={"\u0628\u0633\u062A\u0646"} variant="text" /><div className="flex w-full flex-col gap-4 md:w-auto"><div className="flex flex-row items-center justify-between md:hidden">{appName === "villa" ? <HotelCardReservationInfo {...selectedHotel?.reservationInfo} roomTitle={selectedHotel?.hotelDetail?.roomTitle} size={size} /> : <div className="text-caption">{`${numberConvert(selectedHotel?.reservationInfo?.nightCount, {
                    locale: router.locale
                  })} شب`}</div>}<HotelCardPricing className="text-subtitle-1" {...selectedHotel?.pricing} nightCount={selectedHotel?.reservationInfo?.nightCount} size={size} /></div><Button className="!w-full md:!w-auto" color="primary" loading={clickLoading === selectedHotel?.id} onClick={hotelCardOnClick({
                hotelInfo: selectedHotel,
                index: hotelList?.findIndex(hotel_4 => hotel_4.id === selectedHotel?.id),
                router,
                setClickLoading
              })} text={["villa"].includes(appName) ? "\u0645\u0634\u0627\u0647\u062F\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u0648 \u0631\u0632\u0631\u0648" : "\u0645\u0634\u0627\u0647\u062F\u0647 \u0647\u062A\u0644 \u0648 \u0631\u0632\u0631\u0648"} /></div></div></div></Modal>{selectedHotel && <Modal className="!h-[90vh] overflow-y-scroll rounded-xl md:!h-full md:rounded-none lg:!h-[640px] lg:!w-[720px] lg:!overflow-hidden" onClose={onClose} open={selectedHotel && router?.query?.modal === "map"} showCloseButton={true} title={`موقعیت های مکانی و دسترسی های ${numberConvert(selectedHotel?.hotelDetail?.hotelTitle, {
        locale: router.locale
      })}`} titleClassName="!text-subtitle-1 md:!text-headline-6"><ReserveMap mapOptions={{
          center: {
            lat: toNumber(selectedHotel?.location?.lat),
            lng: toNumber(selectedHotel?.location?.lng)
          }
        }} marker={{
          lat: toNumber(selectedHotel?.location?.lat),
          lng: toNumber(selectedHotel?.location?.lng)
        }} showDescription={false} tile={appName === "hotel-domestic" ? "smapp" : "global"} title="" type="hotel" /><div className="mt-auto flex flex-row justify-end gap-4 pt-4"><Button color="neutral" onClick={onClose} text={"\u0628\u0633\u062A\u0646"} variant="text" /><Button className="w-auto" color="primary" loading={clickLoading === selectedHotel?.id} onClick={hotelCardOnClick({
            hotelInfo: selectedHotel,
            index: hotelList?.findIndex(hotel_5 => hotel_5.id === selectedHotel?.id),
            router,
            setClickLoading
          })} text={["villa"].includes(appName) ? "\u0645\u0634\u0627\u0647\u062F\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u0648 \u0631\u0632\u0631\u0648" : "\u0645\u0634\u0627\u0647\u062F\u0647 \u0647\u062A\u0644 \u0648 \u0631\u0632\u0631\u0648"} /></div></Modal>}<Modal className="!h-[90vh] !max-h-full overflow-y-scroll rounded-xl md:!h-full md:rounded-none lg:!h-[640px] lg:!w-[720px]" headerStyle="!h-16 pb-2" onClose={onClose} open={selectedHotel && (router?.query?.modal === "gallery" || router?.query?.modal === "gallery-details")} showCloseButton={true} title={numberConvert(selectedHotel?.hotelDetail?.hotelTitle, {
        locale: router.locale || "fa"
      })} titleClassName="line-clamp-2" usePortal={true}><div className="grid h-full grid-cols-2 gap-2 overflow-y-auto p-2 lg:px-[calc((100%-750px)/2)] lg:py-6">{containerProps?.map(t8 => {
            let {
              index: index_0,
              rowCount
            } = t8;
            return <ReserveGalleryDetail gallery={selectedHotel?.gallery ?? []} index={index_0} key={`HotelReserveGalleryDetailContainer-${++index_0}`} rowCount={rowCount} />;
          })}</div><ReserveGallerySingle gallery={selectedHotel?.gallery ?? []} /><div className="mt-auto flex flex-row justify-end gap-4 pt-4"><Button color="neutral" onClick={onClose} text={"\u0628\u0633\u062A\u0646"} variant="text" /><Button className="w-auto" color="primary" loading={clickLoading === selectedHotel?.id} onClick={hotelCardOnClick({
            hotelInfo: selectedHotel,
            index: hotelList?.findIndex(hotel_6 => hotel_6.id === selectedHotel?.id),
            router,
            setClickLoading
          })} text={["villa"].includes(appName) ? "\u0645\u0634\u0627\u0647\u062F\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u0648 \u0631\u0632\u0631\u0648" : "\u0645\u0634\u0627\u0647\u062F\u0647 \u0647\u062A\u0644 \u0648 \u0631\u0632\u0631\u0648"} /></div></Modal></section>{hasLoadMoreButton && remainHotels > 0 && <Button color="secondary" fullWidth={true} onClick={onLoadMore} variant="round-outline">مشاهده {numberConvert(remainHotels, {
        locale: "fa"
      })} هتل دیگر</Button>}{loading && <div className={appName === "villa" ? `grid grid-cols-1 gap-2 p-2 md:grid-cols-2 ${router?.pathname?.includes("map") ? "lg:grid-cols-2" : "lg:grid-cols-3"}` : "flex flex-col gap-2"}>{range(6).map(_temp4)}</div>}</>;
};
function _temp(hotel) {
  return hotel.hotelDetail?.isAvailable;
}
function _temp2(hotel_0) {
  return hotel_0.hotelDetail?.isAvailable;
}
function _temp3(hotel_1) {
  return hotel_1.id;
}
function _temp4(indexKey) {
  return <HotelCardSkeleton key={indexKey} size={appName === "villa" ? "small" : "responsive"} />;
}